import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgC3 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "C3",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 100,
				height: 100,
				fill: "#6366F1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.7686 83.7524C40.7686 83.6787 40.7686 82.848 40.7686 81.6374C40.7686 76.6668 44.798 72.6348 49.7686 72.6348V72.6348C54.7391 72.6348 58.7686 76.6642 58.7686 81.6348V83.7524",
				stroke: "#FEFBE5",
				strokeWidth: 15.8824,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M63.2676 14.5312C63.7088 16.7371 65.1205 21.4136 67.2382 22.4724",
				stroke: "#FB923C",
				strokeWidth: 2.64706,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M68.8274 27.7677C68.6157 26.2853 67.8568 23.7971 67.5039 22.7383C69.0921 23.0912 72.3216 24.1148 72.5333 25.3853",
				stroke: "#FB923C",
				strokeWidth: 2.64706,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.707 85.9994C21.707 82.4908 24.5513 79.6465 28.06 79.6465H46.5894C47.7589 79.6465 48.707 80.5946 48.707 81.7641V90.2347C48.707 91.4043 47.7589 92.3524 46.5894 92.3524H28.06C24.5513 92.3524 21.707 89.5081 21.707 85.9994Z",
				fill: "url(#paint0_linear_7220_21627)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M77.8252 85.9994C77.8252 82.4908 74.9809 79.6465 71.4723 79.6465H52.9428C51.7733 79.6465 50.8252 80.5946 50.8252 81.7641V90.2347C50.8252 91.4043 51.7733 92.3524 52.9428 92.3524H71.4723C74.9809 92.3524 77.8252 89.5081 77.8252 85.9994Z",
				fill: "url(#paint1_linear_7220_21627)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.9287 65.862C33.1784 64.9384 34.0163 64.2969 34.973 64.2969H63.4952C64.4519 64.2969 65.2898 64.9384 65.5395 65.862L69.6889 81.215C70.0527 82.561 69.0389 83.8851 67.6446 83.8851H30.8236C29.4293 83.8851 28.4155 82.561 28.7793 81.2149L32.9287 65.862Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter0_d_7220_21627)",
				children: [/* @__PURE__ */ _jsx("g", {
					clipPath: "url(#paint2_diamond_7220_21627_clip_path)",
					"data-figma-skip-parse": "true",
					children: /* @__PURE__ */ _jsxs("g", {
						transform: "matrix(0 0.045 -0.0489706 0 49.5009 50.002)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1006.92,
								height: 1006.36,
								fill: "url(#paint2_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1006.92,
								height: 1006.36,
								transform: "scale(1 -1)",
								fill: "url(#paint2_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1006.92,
								height: 1006.36,
								transform: "scale(-1 1)",
								fill: "url(#paint2_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1006.92,
								height: 1006.36,
								transform: "scale(-1)",
								fill: "url(#paint2_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							})
						]
					})
				}), /* @__PURE__ */ _jsx("path", {
					d: "M43.5588 20.7104C45.6294 15.2367 53.3724 15.2367 55.4429 20.7104L59.4925 31.4161C60.4117 33.8461 62.718 35.4715 65.3156 35.5202L76.489 35.7294C82.6457 35.8447 85.0541 43.7739 80.0015 47.2939L72.0129 52.8594C69.709 54.4645 68.732 57.3917 69.6101 60.0588L72.7027 69.4522C74.5717 75.1289 68.281 80.0108 63.246 76.7911L52.9233 70.1904C50.8367 68.8562 48.165 68.8562 46.0784 70.1904L35.7558 76.7911C30.7207 80.0107 24.43 75.1289 26.299 69.4522L29.3916 60.0588C30.2697 57.3917 29.2927 54.4645 26.9888 52.8594L19.0002 47.2939C13.9476 43.7739 16.356 35.8447 22.5128 35.7294L33.6861 35.5202C36.2837 35.4715 38.59 33.8461 39.5092 31.4161L43.5588 20.7104Z",
					"data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":0.88712340593338013,\"b\":0.29160156846046448,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":0.95402622222900391,\"b\":0.61907553672790527,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":0.88712340593338013,\"b\":0.29160156846046448,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":0.95402622222900391,\"b\":0.61907553672790527,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":5.9971677553475808e-15,\"m01\":-97.941177368164062,\"m02\":98.471450805664062,\"m10\":90.000007629394531,\"m11\":5.5109111278008310e-15,\"m12\":5.0019531250},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.4717 45.2368C44.4717 44.0672 45.4198 43.1191 46.5893 43.1191C47.7589 43.1191 48.707 44.0672 48.707 45.2368V47.3544C48.707 48.524 47.7589 49.4721 46.5893 49.4721C45.4198 49.4721 44.4717 48.524 44.4717 47.3544V45.2368Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50.8271 45.2368C50.8271 44.0672 51.7753 43.1191 52.9448 43.1191C54.1143 43.1191 55.0624 44.0672 55.0624 45.2368V47.3544C55.0624 48.524 54.1143 49.4721 52.9448 49.4721C51.7753 49.4721 50.8271 48.524 50.8271 47.3544V45.2368Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.0615 11.8833C37.0615 10.7137 38.0096 9.76562 39.1792 9.76562H59.2968C60.4664 9.76562 61.4145 10.7137 61.4145 11.8833V27.2362C61.4145 28.4058 60.4664 29.3539 59.2968 29.3539H39.1792C38.0096 29.3539 37.0615 28.4058 37.0615 27.2362V11.8833Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.1807 13.2068C30.1807 11.3063 31.7213 9.76562 33.6218 9.76562H64.8571C66.7576 9.76562 68.2983 11.3063 68.2983 13.2068C68.2983 15.1073 66.7576 16.648 64.8571 16.648H33.6218C31.7213 16.648 30.1807 15.1073 30.1807 13.2068Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.4717 52.1191C47.0423 55.5575 52.1834 55.7385 54.5305 52.1191",
				stroke: "black",
				strokeWidth: 2.11765,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 44.1064,
				y: 64.5312,
				width: 7.05882,
				height: 12.2353,
				rx: .941177,
				transform: "rotate(15 44.1064 64.5312)",
				fill: "url(#paint3_linear_7220_21627)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 7.05882,
				height: 12.2353,
				rx: .941177,
				transform: "matrix(-0.965926 0.258819 0.258819 0.965926 55.2881 64.5312)",
				fill: "url(#paint4_linear_7220_21627)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M47.5294 64.4391C49.4117 65.5258 49.4117 68.2428 47.5294 69.3296L41.1764 72.9974C39.2941 74.0842 36.9411 72.7257 36.9411 70.5522L36.9411 63.2164C36.9411 61.0429 39.2941 59.6844 41.1764 60.7712L47.5294 64.4391Z",
				fill: "url(#paint5_linear_7220_21627)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51.579 64.4391C49.6967 65.5258 49.6967 68.2428 51.579 69.3296L57.932 72.9974C59.8143 74.0842 62.1673 72.7257 62.1673 70.5522L62.1673 63.2164C62.1673 61.0429 59.8143 59.6844 57.932 60.7712L51.579 64.4391Z",
				fill: "url(#paint6_linear_7220_21627)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.1152 63.7251C46.1152 63.3905 46.3865 63.1191 46.7212 63.1191H52.7563C53.091 63.1191 53.3623 63.3905 53.3623 63.7251V70.419C53.3623 70.7537 53.091 71.025 52.7563 71.025H46.7212C46.3865 71.025 46.1152 70.7537 46.1152 70.419V63.7251Z",
				fill: "#E8E8E8"
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter1_d_7220_21627)",
				children: [/* @__PURE__ */ _jsx("g", {
					clipPath: "url(#paint7_diamond_7220_21627_clip_path)",
					"data-figma-skip-parse": "true",
					children: /* @__PURE__ */ _jsxs("g", {
						transform: "matrix(-0.003 0.00519615 -0.00519615 -0.003 16.1454 28.1962)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1166.67,
								height: 1166.67,
								fill: "url(#paint7_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1166.67,
								height: 1166.67,
								transform: "scale(1 -1)",
								fill: "url(#paint7_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1166.67,
								height: 1166.67,
								transform: "scale(-1 1)",
								fill: "url(#paint7_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1166.67,
								height: 1166.67,
								transform: "scale(-1)",
								fill: "url(#paint7_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							})
						]
					})
				}), /* @__PURE__ */ _jsx("path", {
					d: "M18.1718 24.0984C18.3884 23.8541 18.7842 24.0826 18.6809 24.3923L17.599 27.6355C17.561 27.7495 17.5947 27.8752 17.6846 27.9549L20.2431 30.2226C20.4875 30.4392 20.2589 30.835 19.9492 30.7317L16.7061 29.6498C16.592 29.6118 16.4663 29.6454 16.3866 29.7354L14.1189 32.2939C13.9024 32.5382 13.5065 32.3097 13.6098 32L14.6917 28.7568C14.7298 28.6428 14.6961 28.5171 14.6061 28.4374L12.0476 26.1697C11.8033 25.9531 12.0318 25.5573 12.3416 25.6606L15.5847 26.7425C15.6987 26.7805 15.8244 26.7469 15.9041 26.6569L18.1718 24.0984Z",
					"data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.99607843160629272,\"g\":0.94117647409439087,\"b\":0.54117649793624878,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.99607843160629272,\"g\":0.98823529481887817,\"b\":0.90980392694473267,\"a\":1.0},\"position\":0.52999997138977051}],\"stopsVar\":[{\"color\":{\"r\":0.99607843160629272,\"g\":0.94117647409439087,\"b\":0.54117649793624878,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.99607843160629272,\"g\":0.98823529481887817,\"b\":0.90980392694473267,\"a\":1.0},\"position\":0.52999997138977051}],\"transform\":{\"m00\":-6.0,\"m01\":-10.392304420471191,\"m02\":24.341524124145508,\"m10\":10.392304420471191,\"m11\":-6.0,\"m12\":26.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter2_d_7220_21627)",
				children: [/* @__PURE__ */ _jsx("g", {
					clipPath: "url(#paint8_diamond_7220_21627_clip_path)",
					"data-figma-skip-parse": "true",
					children: /* @__PURE__ */ _jsxs("g", {
						transform: "matrix(0 0.006 -0.006 0 86 17)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1166.67,
								height: 1166.67,
								fill: "url(#paint8_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1166.67,
								height: 1166.67,
								transform: "scale(1 -1)",
								fill: "url(#paint8_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1166.67,
								height: 1166.67,
								transform: "scale(-1 1)",
								fill: "url(#paint8_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1166.67,
								height: 1166.67,
								transform: "scale(-1)",
								fill: "url(#paint8_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							})
						]
					})
				}), /* @__PURE__ */ _jsx("path", {
					d: "M85.7061 12.438C85.7715 12.1181 86.2285 12.1181 86.2939 12.438L86.9785 15.7876C87.0026 15.9054 87.0946 15.9974 87.2124 16.0215L90.562 16.7061C90.8819 16.7715 90.8819 17.2285 90.562 17.2939L87.2124 17.9785C87.0946 18.0026 87.0026 18.0946 86.9785 18.2124L86.2939 21.562C86.2285 21.8819 85.7715 21.8819 85.7061 21.562L85.0215 18.2124C84.9974 18.0946 84.9054 18.0026 84.7876 17.9785L81.438 17.2939C81.1181 17.2285 81.1181 16.7715 81.438 16.7061L84.7876 16.0215C84.9054 15.9974 84.9974 15.9054 85.0215 15.7876L85.7061 12.438Z",
					"data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.99607843160629272,\"g\":0.94117647409439087,\"b\":0.54117649793624878,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.99607843160629272,\"g\":0.98823529481887817,\"b\":0.90980392694473267,\"a\":1.0},\"position\":0.52999997138977051}],\"stopsVar\":[{\"color\":{\"r\":0.99607843160629272,\"g\":0.94117647409439087,\"b\":0.54117649793624878,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.99607843160629272,\"g\":0.98823529481887817,\"b\":0.90980392694473267,\"a\":1.0},\"position\":0.52999997138977051}],\"transform\":{\"m00\":1.4009219792657538e-15,\"m01\":-12.0,\"m02\":92.0,\"m10\":12.0,\"m11\":1.4009219792657538e-15,\"m12\":11.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter3_d_7220_21627)",
				children: [/* @__PURE__ */ _jsx("g", {
					clipPath: "url(#paint9_diamond_7220_21627_clip_path)",
					"data-figma-skip-parse": "true",
					children: /* @__PURE__ */ _jsxs("g", {
						transform: "matrix(-0.00519615 0.003 -0.003 -0.00519615 82.3781 71.1962)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1166.67,
								height: 1166.67,
								fill: "url(#paint9_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1166.67,
								height: 1166.67,
								transform: "scale(1 -1)",
								fill: "url(#paint9_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1166.67,
								height: 1166.67,
								transform: "scale(-1 1)",
								fill: "url(#paint9_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							}),
							/* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 1166.67,
								height: 1166.67,
								transform: "scale(-1)",
								fill: "url(#paint9_diamond_7220_21627)",
								opacity: 1,
								shapeRendering: "crispEdges"
							})
						]
					})
				}), /* @__PURE__ */ _jsx("path", {
					d: "M86.1819 68.6606C86.4916 68.5573 86.7202 68.9531 86.4758 69.1697L83.9173 71.4374C83.8274 71.5171 83.7937 71.6428 83.8317 71.7568L84.9136 75C85.0169 75.3097 84.6211 75.5382 84.4045 75.2939L82.1368 72.7354C82.0571 72.6454 81.9314 72.6118 81.8174 72.6498L78.5743 73.7317C78.2645 73.835 78.036 73.4392 78.2803 73.2226L80.8388 70.9549C80.9288 70.8752 80.9625 70.7495 80.9244 70.6355L79.8425 67.3923C79.7392 67.0826 80.1351 66.8541 80.3516 67.0984L82.6193 69.6569C82.699 69.7469 82.8247 69.7805 82.9388 69.7425L86.1819 68.6606Z",
					"data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.99607843160629272,\"g\":0.94117647409439087,\"b\":0.54117649793624878,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.99607843160629272,\"g\":0.98823529481887817,\"b\":0.90980392694473267,\"a\":1.0},\"position\":0.52999997138977051}],\"stopsVar\":[{\"color\":{\"r\":0.99607843160629272,\"g\":0.94117647409439087,\"b\":0.54117649793624878,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.99607843160629272,\"g\":0.98823529481887817,\"b\":0.90980392694473267,\"a\":1.0},\"position\":0.52999997138977051}],\"transform\":{\"m00\":-10.392304420471191,\"m01\":-5.9999995231628418,\"m02\":90.574218750,\"m10\":5.9999995231628418,\"m11\":-10.392304420471191,\"m12\":73.392303466796875},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
				})]
			}),
			/* @__PURE__ */ _jsxs("defs", { children: [
				/* @__PURE__ */ _jsxs("filter", {
					id: "filter0_d_7220_21627",
					x: 11.5963,
					y: 11.9342,
					width: 75.8094,
					height: 70.5555,
					filterUnits: "userSpaceOnUse",
					colorInterpolationFilters: "sRGB",
					children: [
						/* @__PURE__ */ _jsx("feFlood", {
							floodOpacity: 0,
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ _jsx("feColorMatrix", {
							in: "SourceAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
							result: "hardAlpha"
						}),
						/* @__PURE__ */ _jsx("feOffset", {}),
						/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.33564 }),
						/* @__PURE__ */ _jsx("feComposite", {
							in2: "hardAlpha",
							operator: "out"
						}),
						/* @__PURE__ */ _jsx("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.996078 0 0 0 0 0.941176 0 0 0 0 0.541176 0 0 0 0.5 0"
						}),
						/* @__PURE__ */ _jsx("feBlend", {
							mode: "normal",
							in2: "BackgroundImageFix",
							result: "effect1_dropShadow_7220_21627"
						}),
						/* @__PURE__ */ _jsx("feBlend", {
							mode: "normal",
							in: "SourceGraphic",
							in2: "effect1_dropShadow_7220_21627",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ _jsx("clipPath", {
					id: "paint2_diamond_7220_21627_clip_path",
					children: /* @__PURE__ */ _jsx("path", { d: "M43.5588 20.7104C45.6294 15.2367 53.3724 15.2367 55.4429 20.7104L59.4925 31.4161C60.4117 33.8461 62.718 35.4715 65.3156 35.5202L76.489 35.7294C82.6457 35.8447 85.0541 43.7739 80.0015 47.2939L72.0129 52.8594C69.709 54.4645 68.732 57.3917 69.6101 60.0588L72.7027 69.4522C74.5717 75.1289 68.281 80.0108 63.246 76.7911L52.9233 70.1904C50.8367 68.8562 48.165 68.8562 46.0784 70.1904L35.7558 76.7911C30.7207 80.0107 24.43 75.1289 26.299 69.4522L29.3916 60.0588C30.2697 57.3917 29.2927 54.4645 26.9888 52.8594L19.0002 47.2939C13.9476 43.7739 16.356 35.8447 22.5128 35.7294L33.6861 35.5202C36.2837 35.4715 38.59 33.8461 39.5092 31.4161L43.5588 20.7104Z" })
				}),
				/* @__PURE__ */ _jsxs("filter", {
					id: "filter1_d_7220_21627",
					x: 7.94434,
					y: 19.9961,
					width: 16.4014,
					height: 16.4004,
					filterUnits: "userSpaceOnUse",
					colorInterpolationFilters: "sRGB",
					children: [
						/* @__PURE__ */ _jsx("feFlood", {
							floodOpacity: 0,
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ _jsx("feColorMatrix", {
							in: "SourceAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
							result: "hardAlpha"
						}),
						/* @__PURE__ */ _jsx("feOffset", {}),
						/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
						/* @__PURE__ */ _jsx("feComposite", {
							in2: "hardAlpha",
							operator: "out"
						}),
						/* @__PURE__ */ _jsx("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.996078 0 0 0 0 0.941176 0 0 0 0 0.541176 0 0 0 1 0"
						}),
						/* @__PURE__ */ _jsx("feBlend", {
							mode: "normal",
							in2: "BackgroundImageFix",
							result: "effect1_dropShadow_7220_21627"
						}),
						/* @__PURE__ */ _jsx("feBlend", {
							mode: "normal",
							in: "SourceGraphic",
							in2: "effect1_dropShadow_7220_21627",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ _jsx("clipPath", {
					id: "paint7_diamond_7220_21627_clip_path",
					children: /* @__PURE__ */ _jsx("path", { d: "M18.1718 24.0984C18.3884 23.8541 18.7842 24.0826 18.6809 24.3923L17.599 27.6355C17.561 27.7495 17.5947 27.8752 17.6846 27.9549L20.2431 30.2226C20.4875 30.4392 20.2589 30.835 19.9492 30.7317L16.7061 29.6498C16.592 29.6118 16.4663 29.6454 16.3866 29.7354L14.1189 32.2939C13.9024 32.5382 13.5065 32.3097 13.6098 32L14.6917 28.7568C14.7298 28.6428 14.6961 28.5171 14.6061 28.4374L12.0476 26.1697C11.8033 25.9531 12.0318 25.5573 12.3416 25.6606L15.5847 26.7425C15.6987 26.7805 15.8244 26.7469 15.9041 26.6569L18.1718 24.0984Z" })
				}),
				/* @__PURE__ */ _jsxs("filter", {
					id: "filter2_d_7220_21627",
					x: 77.1982,
					y: 8.19727,
					width: 17.6035,
					height: 17.6055,
					filterUnits: "userSpaceOnUse",
					colorInterpolationFilters: "sRGB",
					children: [
						/* @__PURE__ */ _jsx("feFlood", {
							floodOpacity: 0,
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ _jsx("feColorMatrix", {
							in: "SourceAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
							result: "hardAlpha"
						}),
						/* @__PURE__ */ _jsx("feOffset", {}),
						/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
						/* @__PURE__ */ _jsx("feComposite", {
							in2: "hardAlpha",
							operator: "out"
						}),
						/* @__PURE__ */ _jsx("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.996078 0 0 0 0 0.941176 0 0 0 0 0.541176 0 0 0 1 0"
						}),
						/* @__PURE__ */ _jsx("feBlend", {
							mode: "normal",
							in2: "BackgroundImageFix",
							result: "effect1_dropShadow_7220_21627"
						}),
						/* @__PURE__ */ _jsx("feBlend", {
							mode: "normal",
							in: "SourceGraphic",
							in2: "effect1_dropShadow_7220_21627",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ _jsx("clipPath", {
					id: "paint8_diamond_7220_21627_clip_path",
					children: /* @__PURE__ */ _jsx("path", { d: "M85.7061 12.438C85.7715 12.1181 86.2285 12.1181 86.2939 12.438L86.9785 15.7876C87.0026 15.9054 87.0946 15.9974 87.2124 16.0215L90.562 16.7061C90.8819 16.7715 90.8819 17.2285 90.562 17.2939L87.2124 17.9785C87.0946 18.0026 87.0026 18.0946 86.9785 18.2124L86.2939 21.562C86.2285 21.8819 85.7715 21.8819 85.7061 21.562L85.0215 18.2124C84.9974 18.0946 84.9054 18.0026 84.7876 17.9785L81.438 17.2939C81.1181 17.2285 81.1181 16.7715 81.438 16.7061L84.7876 16.0215C84.9054 15.9974 84.9974 15.9054 85.0215 15.7876L85.7061 12.438Z" })
				}),
				/* @__PURE__ */ _jsxs("filter", {
					id: "filter3_d_7220_21627",
					x: 74.1777,
					y: 62.9961,
					width: 16.4014,
					height: 16.4004,
					filterUnits: "userSpaceOnUse",
					colorInterpolationFilters: "sRGB",
					children: [
						/* @__PURE__ */ _jsx("feFlood", {
							floodOpacity: 0,
							result: "BackgroundImageFix"
						}),
						/* @__PURE__ */ _jsx("feColorMatrix", {
							in: "SourceAlpha",
							type: "matrix",
							values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
							result: "hardAlpha"
						}),
						/* @__PURE__ */ _jsx("feOffset", {}),
						/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
						/* @__PURE__ */ _jsx("feComposite", {
							in2: "hardAlpha",
							operator: "out"
						}),
						/* @__PURE__ */ _jsx("feColorMatrix", {
							type: "matrix",
							values: "0 0 0 0 0.996078 0 0 0 0 0.941176 0 0 0 0 0.541176 0 0 0 1 0"
						}),
						/* @__PURE__ */ _jsx("feBlend", {
							mode: "normal",
							in2: "BackgroundImageFix",
							result: "effect1_dropShadow_7220_21627"
						}),
						/* @__PURE__ */ _jsx("feBlend", {
							mode: "normal",
							in: "SourceGraphic",
							in2: "effect1_dropShadow_7220_21627",
							result: "shape"
						})
					]
				}),
				/* @__PURE__ */ _jsx("clipPath", {
					id: "paint9_diamond_7220_21627_clip_path",
					children: /* @__PURE__ */ _jsx("path", { d: "M86.1819 68.6606C86.4916 68.5573 86.7202 68.9531 86.4758 69.1697L83.9173 71.4374C83.8274 71.5171 83.7937 71.6428 83.8317 71.7568L84.9136 75C85.0169 75.3097 84.6211 75.5382 84.4045 75.2939L82.1368 72.7354C82.0571 72.6454 81.9314 72.6118 81.8174 72.6498L78.5743 73.7317C78.2645 73.835 78.036 73.4392 78.2803 73.2226L80.8388 70.9549C80.9288 70.8752 80.9625 70.7495 80.9244 70.6355L79.8425 67.3923C79.7392 67.0826 80.1351 66.8541 80.3516 67.0984L82.6193 69.6569C82.699 69.7469 82.8247 69.7805 82.9388 69.7425L86.1819 68.6606Z" })
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint0_linear_7220_21627",
					x1: 35.207,
					y1: 79.6465,
					x2: 35.207,
					y2: 92.3524,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFFDED" }), /* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FCF7CF"
					})]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint1_linear_7220_21627",
					x1: 64.3252,
					y1: 79.6465,
					x2: 64.3252,
					y2: 92.3524,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFFDED" }), /* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FCF7CF"
					})]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint2_diamond_7220_21627",
					x1: 0,
					y1: 0,
					x2: 500,
					y2: 500,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFE24A" }), /* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FFF39E"
					})]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint3_linear_7220_21627",
					x1: 47.6359,
					y1: 64.5313,
					x2: 47.6359,
					y2: 76.7665,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#959595" }), /* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#E8E8E8"
					})]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint4_linear_7220_21627",
					x1: 3.52941,
					y1: 0,
					x2: 3.52941,
					y2: 12.2353,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#959595" }), /* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#E8E8E8"
					})]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint5_linear_7220_21627",
					x1: 51.7646,
					y1: 66.8843,
					x2: 31.9999,
					y2: 66.8843,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C0C0C0" }), /* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#E8E8E8"
					})]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint6_linear_7220_21627",
					x1: 47.3438,
					y1: 66.8843,
					x2: 67.1085,
					y2: 66.8843,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C0C0C0" }), /* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#E8E8E8"
					})]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint7_diamond_7220_21627",
					x1: 0,
					y1: 0,
					x2: 500,
					y2: 500,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FEF08A" }), /* @__PURE__ */ _jsx("stop", {
						offset: .53,
						stopColor: "#FEFCE8"
					})]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint8_diamond_7220_21627",
					x1: 0,
					y1: 0,
					x2: 500,
					y2: 500,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FEF08A" }), /* @__PURE__ */ _jsx("stop", {
						offset: .53,
						stopColor: "#FEFCE8"
					})]
				}),
				/* @__PURE__ */ _jsxs("linearGradient", {
					id: "paint9_diamond_7220_21627",
					x1: 0,
					y1: 0,
					x2: 500,
					y2: 500,
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FEF08A" }), /* @__PURE__ */ _jsx("stop", {
						offset: .53,
						stopColor: "#FEFCE8"
					})]
				})
			] })
		]
	})
});
export default SvgC3;
